import { mediaQueries } from "../constants";
import { useMediaQuery } from "react-responsive";

const useResponsive = () => {
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isLandscape = useMediaQuery({ query: "(orientation: landscape)" });

  const isMobilePortrait =
    useMediaQuery({ query: mediaQueries.xs }) && isPortrait;

  const isMobileLandscape =
    useMediaQuery({ query: mediaQueries.sm }) && isLandscape;
  const isTabletPortrait =
    useMediaQuery({ query: mediaQueries.md }) && isPortrait;
  const isTabletLandscape =
    useMediaQuery({ query: mediaQueries.lg }) && isLandscape;

  const isModalMobileLandscape =
    useMediaQuery({
      query:
        "(min-width: 575.98px) and (max-width: 991.98px) and (max-height: 430.98px)",
    }) && isLandscape;

  const isMobile = isMobilePortrait || isMobileLandscape;
  const isTablet = isTabletPortrait || isTabletLandscape;

  return {
    isMobilePortrait,
    isMobileLandscape,
    isMobile,
    isTabletPortrait,
    isTabletLandscape,
    isTablet,
    isModalMobileLandscape,
  };
};

export default useResponsive;
